export const insuranceConstants = {
  showModifiedQuotationMs: 5000
};
